import './style.scss';
import PortalReviewsFilter from './portal_reviews_filter.vue';

new Vue({
  el: '.vue-portal-reviews-filter',
  components: {
    'portal-reviews-filter': PortalReviewsFilter,
  },
});
